import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { TextHighlightModule } from '../text-highlight';
import { TreeViewModule } from '../treeview/treeview.module';
import { ScanSelectionTreeComponent } from './scan-selection-tree.component';

@NgModule({
    imports: [CommonModule, FormsModule, TwcModule, TreeViewModule, TranslateModule, TextHighlightModule],
    exports: [ScanSelectionTreeComponent],
    declarations: [ScanSelectionTreeComponent],
})
export class ScanSelectionTreeModule {}
